import { Component, Input } from '@angular/core';
import { IDataTagTransfer } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-tag-small',
	templateUrl: './tag-small.component.html',
	styleUrls: ['./tag-small.component.scss']
})
export class TagSmallComponent {
	@Input() item!: IDataTagTransfer;
}
